var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09008 6.5C8.03377 6.49436 7.9662 6.49436 7.90426 6.5C6.56419 6.4549 5.5 5.35569 5.5 4.00282C5.5 2.62176 6.61487 1.5 7.99999 1.5C9.3795 1.5 10.5 2.62176 10.5 4.00282C10.4944 5.35569 9.43017 6.4549 8.09008 6.5Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33065 9.45506C2.55645 10.5823 2.55645 12.4194 4.33065 13.5397C6.34677 14.8201 9.65323 14.8201 11.6694 13.5397C13.4435 12.4124 13.4435 10.5754 11.6694 9.45506C9.66056 8.18165 6.35411 8.18165 4.33065 9.45506Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.fb52f9468dca2d2aa00aee999e6f66c1.svg";
export { ForwardRef as ReactComponent };